import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { RestService } from "@stdoutsrl/design-kit"
import { api } from "../../environments/environment";
import {  Message } from "@stdoutsrl/design-kit";
import { LoaderService } from "../service/loader.service";

@Component({
  selector: "app-recovery-password",
  templateUrl: "./recovery-password.component.html",
  styles: [],
  standalone: false,
})
export class RecoveryPasswordComponent {
  constructor(
    private router: Router,
    private rest: RestService,
    private loader: LoaderService,
    private message: Message
  ) {}

  email: string = "";
  showPassword = false;

  manageCredentials(variableName: "email", value: any) {
    if (value?.value) {
      this[variableName] = value?.value;
    }
  }

  backToLogin() {
    this.router.navigate(["/login"]);
  }
  sendEmail() {
    this.loader.on();
    this.rest
      .post(api.endpoint.sendEmailRecovery, {
        email: this.email,
      })
      .subscribe({
        next: () => {
          this.loader.off(true);
          this.message.showMessage(
            "Email di recupero password inviata",
            "success",
            "message-fix-index"
          );
        },
        error: (error) => {
          this.loader.off(true);
          this.message.showMessage(
            error.error.message,
            "error",
            "message-fix-index"
          );
        },
      });
  }
}
